module.exports = __webpack_public_path__ + "media/images/icons/handpicked-176140654653c9e953ccfefe8cb21e0d.svg";